<template>
  <el-dialog
    title="泉意全网流量多维赋能系统"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
              prop="platform_id"
              label="类型"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.platform_id"
                placeholder="请选择"
                width="50"
        >

          <el-option
                  v-for="item in typeOptions3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>


        </el-select>
      </el-form-item>


      <el-form-item
              prop="url"
              label="URL"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.url"></el-input>
      </el-form-item>

      <el-form-item
              prop="remarks"
              label="备注"
      >
        <el-input v-model="form.remarks"></el-input>
      </el-form-item>











      <el-form-item
              prop="stat"
              label="是否上架"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.stat"
                placeholder="请选择"
                width="50"
        >

          <el-option
                  v-for="item in typeOptions4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>


        </el-select>
      </el-form-item>


      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
  import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "agentEditForm",
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
        formEdit2: true,
      loading: false,
      dialogVisible: false,
        pickerOptions: {}, // 日期设置对象
      form: {
        platform_id: "",
        platform_name: "",
        url: "",
        remarks: "",
        stat: ""


      },
      typeOptions4: [{
        value: "0",
        label: "下架"
      },
        {
          value: "1",
          label: "上架"
        }],
        typeOptions3: [ {
          value: "001",
          label: "淘宝"
        },
          {
            value: "002",
            label: "抖音"
          },

          {
            value: "003",
            label: "快手"
          },

          {
            value: "004",
            label: "西瓜视频"
          },

          {
            value: "005",
            label: "小红书"
          }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();

      if (this.agent.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
        form.platform_id = this.agent.platform_id;
        form.platform_name = this.agent.platform_name;
        form.url = this.agent.url;
        form.remarks = this.agent.remarks;


        form.stat = this.agent.stat;



          this.form = form;
       // });
          this.formEdit = true;
          this.formEdit2=false;
      } else {

          this.formEdit = true;
          this.formEdit2=true;
        //this.form = {};
      }
    },

    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
              if( this.form.platform_id=="001"){
                this.form.platform_name="淘宝"
              }else if( this.form.platform_id=="002"){
                this.form.platform_name="抖音"
              }else if( this.form.platform_id=="003"){
                this.form.platform_name="快手"
              }else if( this.form.platform_id=="004"){
                this.form.platform_name="西瓜视频"
              }else if( this.form.platform_id=="005"){
                this.form.platform_name="小红书"
              }
                this.loading = true;
          agentService.savePlatform({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.id ,xt_id:util.cookies.get('xt_id')})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });

        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

